import styled from 'styled-components'

import TableBase from '@/app/components/Table'
import { HeaderCell } from '@/app/components/Table/Headers'
import { RowCell } from '@/app/components/Table/Row'
import { colors, spaces } from '@/config/global-parameters'

import elecciones from '../../types/elecciones'
import getTableColumns from './tableColumns'
import { IComparadorElecciones } from './types'

export interface IListVotesPerElectionTable {
  circumscriptionId?: string | number
  communeId?: string
  evolucionPorLista: IComparadorElecciones //TODO no optional
}

const filterScope = ({
  circumscriptionId,
  communeId,
  evolucionPorLista,
}: {
  evolucionPorLista: IComparadorElecciones
  circumscriptionId?: string | number
  communeId?: string
}) => {
  if (communeId) return evolucionPorLista.comunas[communeId]
  if (circumscriptionId) return evolucionPorLista.circunscripciones[circumscriptionId]
  return evolucionPorLista.resultados_pais.map((result) => ({
    ...result,
    id: result.eleccion,
  }))
}

const ListVotesPerElectionTable = ({
  circumscriptionId,
  communeId,
  evolucionPorLista, // TODO no default
}: IListVotesPerElectionTable) => {
  const filteredData = filterScope({
    circumscriptionId,
    communeId,
    evolucionPorLista,
  })
    .sort(
      (eleccionA, eleccionB) =>
        elecciones[eleccionA.eleccion].order - elecciones[eleccionB.eleccion].order
    )

  if (!filteredData) return <div>Información no disponible</div>

  return (
    <Table
      columns={getTableColumns()}
      data={filteredData}
    />
  )
}

const Table = styled(TableBase)`
  overflow-y: auto;
  width: 100%;
  ${HeaderCell} {
    min-width: 110px;
    display: flex;
    justify-content: center;
    text-align: center;
    background-color: white;
    &:first-child {
      justify-content: start;
      border-right: 0.5px solid ${colors.colorBlack};
      padding-left: ${spaces.s};
      z-index: 1;
      position: sticky;
      top: 0;
      left: 0;
      box-shadow: 0px 19px 20px 0px rgba(0, 0, 0, 0.3);
      @media (max-width: ${spaces.tabletBreakpoint}) {
        padding-left: ${spaces.xs};
      }
    }
    &:nth-child(6) {
      border-right: 0.5px solid ${colors.colorGrey15};
    }
  }
  ${RowCell} {
    padding: ${spaces.s} ${spaces.s};
    min-height: 0px;
    font-size: 13px;
    background-color: ${colors.colorWhite};
    &:first-child {
      white-space: nowrap;
      border-right: 0.5px solid ${colors.colorBlack};
      z-index: 1;
      position: sticky;
      top: 0;
      left: 0;
      box-shadow: 0px 19px 20px 0px rgba(0, 0, 0, 0.3);
      white-space: normal;
    }
    &:nth-child(6) {
      border-right: 0.5px solid ${colors.colorGrey15};
    }
    @media (max-width: ${spaces.tabletBreakpoint}) {
      padding: ${spaces.s} ${spaces.xs};
    }
  }
`

export default ListVotesPerElectionTable
